export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const DEFAULT_STOCK = {
  cashCenterId: "",
  customerId: "",
  description: "",
  currency: "",
  multiple: "",
  cassetteType: "",
  maker: "",
  limit: 0,
  topSerialNo: "",
  bottomSerialNo: "",
};

export const CASSETTES_TYPES = [
  {
    id: "Type 1",
    text: "Type 1",
  },
  {
    id: "Type 2",
    text: "Type 2",
  },
  {
    id: "Type 3",
    text: "Type 3",
  },
  {
    id: "Type 4",
    text: "Type 4",
  },
  {
    id: "Type 5",
    text: "Type 5",
  },
  {
    id: "Type 6",
    text: "Type 6",
  },
];
